import { render } from "./SubpageNav.vue?vue&type=template&id=2db1e7be&scoped=true"
const script = {}

import "./SubpageNav.vue?vue&type=style&index=0&id=2db1e7be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db1e7be"]])

export default __exports__